module.exports = __webpack_public_path__ + "img/bigData.72ad10fb.jpg";